module.exports = __webpack_public_path__ + "img/shiba-head-level3.ccd11bb7.png";